// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckinController from "./checkin_controller"
import CameraController from "./camera_controller"
import ClockLocationController from "./clock_location_controller"
import UserLookupController from "./user_lookup_controller"
import AutoSubmitController from "./auto_submit_controller"
import CourseSelectionController from "./course_selection_controller"
import CourseScheduleController from "./course_schedule_controller"
import CourseScheduleFormController from "./course_schedule_form_controller"
import EditNotesController from "./edit_notes_controller"
import RevealController from "@stimulus-components/reveal"
import HwComboboxController from "@josefarias/hotwire_combobox"
import RevenueAssigneeController from "./revenue_assignee_controller"
import ScoreDetailsController from "./score_details_controller"
import ScrollToPanelController from "./scroll_to_panel_controller"
import ParticipantEntryController from "./participant_entry_controller"
import PerformanceEntryController from "./performance_entry_controller"
import FrameHistoryController from "./frame_history_controller"
import BillPhotoController from "./bill_photo_controller"
import ScoreSliderController from "./score_slider_controller"
import MemberModalController from "./member_modal_controller"
import RolePermissionsController from "./role_permissions_controller"
import DiscountToggleController from "./discount_toggle_controller"
import PayerModeController from "./payer_mode_controller"
import MemberWizardController from "./member_wizard_controller"
import RevenueSharesController from "./revenue_shares_controller"

application.register("checkin", CheckinController)
application.register("camera", CameraController)
application.register("clock-location", ClockLocationController)
application.register("user-lookup", UserLookupController)
application.register("auto-submit", AutoSubmitController)
application.register("course-selection", CourseSelectionController)
application.register("course-schedule", CourseScheduleController)
application.register("course-schedule-form", CourseScheduleFormController)
application.register("edit-notes", EditNotesController)
application.register("reveal", RevealController)
application.register("hw-combobox", HwComboboxController)
application.register("revenue-assignee", RevenueAssigneeController)
application.register("score-details", ScoreDetailsController)
application.register("scroll-to-panel", ScrollToPanelController)
application.register("participant-entry", ParticipantEntryController)
application.register("performance-entry", PerformanceEntryController)
application.register("frame-history", FrameHistoryController)
application.register("bill-photo", BillPhotoController)
application.register("score-slider", ScoreSliderController)
application.register("member-modal", MemberModalController)
application.register("role-permissions", RolePermissionsController)
application.register("discount-toggle", DiscountToggleController)
application.register("payer-mode", PayerModeController)
application.register("member-wizard", MemberWizardController)
application.register("revenue-shares", RevenueSharesController)
